// src/mobile/MobileReviews.js
import React from "react";
import GoogleReviews from "../components/GoogleReviews";

const MobileReviews = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#0d2b3e" }}>Reviews</h2>
      <GoogleReviews />
    </div>
  );
};

export default MobileReviews;
